/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-15 14:30:43
 */
import ColumnTypes from '@/utils/ColumnTypes';

const myActivities = {
	key: 'myActivities',
	label: '商品信息',
	type: ColumnTypes.channelShopCell,
	isKs: true,
	minWidth: '400',
	fixed: 'left',
};
const contact_user_type_desc = {
	key: 'contact_user_type_desc',
	label: '推广者信息',
	type: ColumnTypes.TextCell,
	minWidth: '130',
};
const product_status_desc = {
	key: 'product_status_desc',
	label: '商品状态',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const item_name = {
	key: 'item_name',
	label: '用户信息',
	isKs: true,
	type: ColumnTypes.cooperationInfoCell,
	minWidth: '160',
};
const commission_rate = {
	key: 'commission_rate',
	label: '佣金率',
	type: ColumnTypes.serviceRateCell,
	isShow: true,
	minWidth: '100',
};
const service_rate = {
	key: 'service_rate',
	label: '服务费率',
	type: ColumnTypes.serviceRateCell,
	isShow: true,
	minWidth: '120',
};
const item_apply_time = {
	key: 'item_apply_time',
	label: '报名时间',
	minWidth: '180',
	type: ColumnTypes.TextCell,
};
const extension_time = {
	key: 'extension_time',
	label: '合作推广时间',
	minWidth: '200',
	startTime: 'apply_start_time',
	endTime: 'apply_end_time',
	type: () => import('./components/tableCell/extensionTimeCell.vue'),
};
const state = {
	key: 'state',
	label: '报名状态',
	type: ColumnTypes.auditStatusCell,
	minWidth: '160',
};

const operations = {
	key: 'operations',
	label: '操作',
	minWidth: '80',
	fixed: 'right',
	type: ColumnTypes.ButtonsCell,
	align: 'right',
};

export const columns = [
	myActivities,
	contact_user_type_desc,
	product_status_desc,
	item_name,
	commission_rate,
	service_rate,
	item_apply_time,
	extension_time,
	state,
	operations,
];
